/**
 * Parse a route or query parameter as a positive integer id (>= 1).
 * Use for path params and numeric query params (e.g. synchronization ?id=).
 */
export function parsePositiveIntRouteParam(
  value: string | number | null | undefined,
): number | null {
  if (value == null) return null;
  const s = String(value).trim();
  if (s === '') return null;
  if (!/^\d+$/.test(s)) return null;
  const n = Number.parseInt(s, 10);
  if (Number.isNaN(n) || n < 1) return null;
  return n;
}
